import { text } from './fonts';
export const forms = {
    /*
    legacy default variant that gonna be deprecated
    once we fully migrate  to the new form components
    */
    label: Object.assign({ display: 'block', mb: 'xxs', color: 'neutralTextWeak' }, text.Subhead),
    // intended to be used for Radio & Checkbox components
    chocoLabel: Object.assign({ userSelect: 'none', justifyContent: 'space-between', alignItems: 'center', px: 'm', py: 'm' }, text.Body),
    ChocoCheckboxFormField: {
        userSelect: 'none',
        alignItems: 'center',
    },
    // intended to be used for standalone Checkbox components
    checkBoxLabel: {
        cursor: 'pointer',
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%',
        height: '100%',
    },
    // intended to be used for the rest of the form components
    chocoInputLabel: Object.assign(Object.assign({ display: 'block' }, text.Subhead), { mb: 'xxs' }),
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZm9ybXMuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvdGhlbWUvZm9ybXMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBRUEsT0FBTyxFQUFFLElBQUksRUFBRSxNQUFNLFNBQVMsQ0FBQztBQUUvQixNQUFNLENBQUMsTUFBTSxLQUFLLEdBQXVDO0lBQ3ZEOzs7TUFHRTtJQUNGLEtBQUssa0JBQ0gsT0FBTyxFQUFFLE9BQU8sRUFDaEIsRUFBRSxFQUFFLEtBQUssRUFDVCxLQUFLLEVBQUUsaUJBQWlCLElBQ3JCLElBQUksQ0FBQyxPQUFPLENBQ2hCO0lBQ0Qsc0RBQXNEO0lBQ3RELFVBQVUsa0JBQ1IsVUFBVSxFQUFFLE1BQU0sRUFDbEIsY0FBYyxFQUFFLGVBQWUsRUFDL0IsVUFBVSxFQUFFLFFBQVEsRUFDcEIsRUFBRSxFQUFFLEdBQUcsRUFDUCxFQUFFLEVBQUUsR0FBRyxJQUNKLElBQUksQ0FBQyxJQUFJLENBQ2I7SUFDRCxzQkFBc0IsRUFBRTtRQUN0QixVQUFVLEVBQUUsTUFBTTtRQUNsQixVQUFVLEVBQUUsUUFBUTtLQUNyQjtJQUNELHlEQUF5RDtJQUN6RCxhQUFhLEVBQUU7UUFDYixNQUFNLEVBQUUsU0FBUztRQUNqQixjQUFjLEVBQUUsUUFBUTtRQUN4QixVQUFVLEVBQUUsUUFBUTtRQUNwQixLQUFLLEVBQUUsTUFBTTtRQUNiLE1BQU0sRUFBRSxNQUFNO0tBQ2Y7SUFDRCwwREFBMEQ7SUFDMUQsZUFBZSxnQ0FDYixPQUFPLEVBQUUsT0FBTyxJQUNiLElBQUksQ0FBQyxPQUFPLEtBQ2YsRUFBRSxFQUFFLEtBQUssR0FDVjtDQUNGLENBQUMifQ==